import saveStatus from '@gqlapp/base/utils/saveStatus';

import withProps from "recompose/withProps";
import UserFormatter from "../UserFormatter";


/**
 * onUpdate
 * @param Save
 * @param refetchCurrentUser
 * @param id
 * @returns {function(*=): Promise<*|undefined>}
 */
export const onUpdate = (Save, { refetchCurrentUser, currentUser:{ id } = {} }) => async input => {
  input = UserFormatter.trimExtraSpaces(input);
  const values = await Save({ input, id });
  try{ refetchCurrentUser();}catch (e) {}
  return saveStatus({ values, errorMsg: 'user:update.errorMsg'.t() });
};


/**
 * onCreate
 * @param Save
 * @returns {function(*): Promise<any>}
 */
export const onCreate = (Save) => async (input) => {
  input = UserFormatter.trimExtraSpaces(input);
  const values = await Save({ input });
  return saveStatus({ values, errorMsg: 'user:update.errorMsg'.t() });
};

/**
 * onError
 * @param alert
 * @param setErrors
 * @param e
 */
const onError = ({ errorCatch, setErrors }, e) => {
  try{ setErrors(e) }catch (e) {}
  errorCatch(e);
}


const onSave = ({ alert }) =>{
  alert({ message: 'user:update.saved'.t(), type: 'success' })
}

export const withUserProcess = withProps(({ currentUser, userRegister, userCreate, userUpdate, ...props })=>({
  onRegister: onCreate(userRegister),
  onCreate: onCreate(userCreate),
  onUpdate: onUpdate(userUpdate, {...props, currentUser }),
  onSubmit: onUpdate(userUpdate, {...props, currentUser }),
  onSave: onSave,
  onError: onError,
  user: currentUser,
}));

export default withUserProcess;
